import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { getOffset } from '@opten/dom/get-offset';
import { Collapse } from '@opten/collapse/initializer';
import { getSelectorElementFromElement } from '@opten/dom/get-selector-element-from-element';
import { getCss } from '@opten/dom/get-css';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { getStickyOffset } from '../../../Opten.HypothekarbankLenzburg.Web.Static/app/utilities/scroll-helper';
import { hasClass } from '@opten/dom/has-class';
import { isPad } from '../utilities/detection';

// todo: way to bind it do data-anchor?
@Component({ className: 'js-anchor' })
export class Anchor implements OnInit {
    private _cookieConsent: HTMLElement;


    constructor(private element: HTMLElement) {
        this._cookieConsent = document.getElementsByClassName(
            'js-cookie-consent'
        )[0] as HTMLElement;
        // check if we have a cookie consent (animation)
        if (this._cookieConsent) {
            // wait till cookie has animated
            this._cookieConsent.addEventListener(
                'shown.hbl.cookie-consent',
                this._handleCookieConsent
            );
        }
    }

    onInit() {
        this.check();
        window.addEventListener('hashchange', () => this.check());
        window.addEventListener('popstate', () => this.check());

    }

    check() {
        if (this._canScroll()) {

            /*if (this._cookieConsent) {// check if we have a cookie consent (animation)
                // wait till cookie has animated
                this._cookieConsent.addEventListener(
                    'shown.hbl.cookie-consent',
                    this._handleCookieConsent
                );
            } else {*/
            // otherwise just scroll to the element
            var sidebarPanel = document.getElementById('c-sidebar-panel');
            if (sidebarPanel && hasClass(sidebarPanel, '--collapsed') == false) {
                var closeElement = Array.from(document.getElementsByClassName('js-sidebar-close')) as Array<HTMLElement>;
                if (closeElement) {
                    closeElement[0].click();
                    setTimeout(() => {
                        this._scroll();
                    }, 650);
                }
            }
            else {
                this._scroll();
            }
            /*}*/
        }
    }

    private _canScroll(): boolean {
        const hash = window.location.hash;

        return hash && hash.indexOf('#anchor-') !== -1;
    }

    private getElement(): HTMLElement {
        if (this._canScroll()) {
            return this.element.querySelector(
                `[data-anchor='${window.location.hash.substring(1)}']`
            );
        }

        return null;
    }

    private _scroll() {
        const element = this.getElement();

        if (element) {
            // check if it's an accordion element, so we can open it
            if (element.getAttribute('data-toggle') === 'collapse') {
                const target = getSelectorElementFromElement(
                    element,
                    'data-target',
                    true
                );

                if (target) {
                    const api = new Collapse(target);

                    // check if the collapse is already open
                    // because then the shown event might not be triggered!
                    if (api.isOpen()) {
                        this._animate();
                    } else {
                        target.addEventListener(
                            'shown.opten.collapse',
                            this._handleCollapse
                        );

                        api.show();
                    }
                } else {
                    // fallback
                    this._animate();
                }
            } else {
                // otherwise just scroll to the element...
                this._animate();
            }
        }
    }

    private _animate() {
        const element = this.getElement();

        if (element) {
            let offset = getOffset(element).top();

            offset += parseCssUnit(getCss(element, 'margin-top')) * -1;
			offset += getStickyOffset() * -1;
			if(isPad() == false){
				offset += 95; // header desktop height
			}

            offset = Math.round(offset);

            window.scrollTo(0, offset);
        }
    }

    private _handleCollapse = () => {
        this._animate();

        this._cookieConsent.removeEventListener(
            'shown.opten.collapse',
            this._handleCollapse
        );
    }

    private _handleCookieConsent = () => {
        this._scroll();

        this._cookieConsent.removeEventListener(
            'shown.hbl.cookie-consent',
            this._handleCookieConsent
        );
    }
}
